exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footercustom {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1rem;\n  background-color: black;\n  text-align: center;\n}\n\na.footer { color: white; padding: 5px;text-decoration: none; }\na.footer:visited { color: white; }\na.footer:hover { color: white; text-decoration: underline;}\n.router-link-active { color: gainsboro; background-color: #52b9e9; text-decoration: none; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/globant/site/src/app/components/ui/app-footer/app-footer.component.css
// module id = ../../../../../src/app/components/ui/app-footer/app-footer.component.css
// module chunks = main